import React, { useEffect } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { useNavigate } from 'react-router-dom';
import { Loading } from '~/shared/Loading';

/**
 * Component that handles the redirect callback from Microsoft login.
 * Waits until MSAL has processed the redirect and the user is authenticated
 * before navigating to the target page. If MSAL finishes and the user still
 * isn't authenticated (e.g. a stale callback URL whose state doesn't match),
 * restarts the login flow instead of hanging.
 */
export function MsalLoginCallback() {
	const isAuthenticated = useIsAuthenticated();
	const { inProgress } = useMsal();
	const navigate = useNavigate();

	useEffect(() => {
		if (isAuthenticated) {
			const redirectUri = sessionStorage.getItem('redirectUri');
			sessionStorage.removeItem('redirectUri');
			navigate(redirectUri ?? '/', { replace: true });
		} else if (inProgress === InteractionStatus.None) {
			navigate('/login', { replace: true });
		}
	}, [isAuthenticated, inProgress, navigate]);

	return <Loading message="Redirecting to login page..." />;
}
